// Componente GestionCuenta
// Vista intermedia para gestionar la cuenta del usuario
// Muestra un card con opciones de seguridad y configuración

import React from 'react';
import { FiAtSign, FiLock, FiXCircle, FiChevronRight, FiArrowLeft } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';

/**
 * Componente GestionCuenta
 * 
 * Vista intermedia que muestra opciones de gestión de cuenta
 * Permite acceder a cambiar email, contraseña y desactivar cuenta
 * Diseño tipo settings con estructura clara
 */
const GestionCuenta = () => {
  const navigate = useNavigate();

  /**
   * Componente de item de menú
   * Muestra una opción con icono, título y flecha de navegación
   */
  const MenuItem = ({ icon: Icon, title, subtitle, onClick, danger = false, last = false }) => (
    <button
      onClick={onClick}
      className={`w-full flex items-center justify-between p-4 hover:bg-neutral-800/50 transition-colors ${!last ? 'border-b border-neutral-700/30' : ''} ${danger ? 'text-red-400' : 'text-white'}`}
    >
      <div className="flex items-center space-x-4">
        <div className={`p-2 rounded-lg ${danger ? 'bg-red-500/20' : 'bg-neutral-500/20'}`}>
          <Icon className={`h-5 w-5 ${danger ? 'text-red-400' : 'text-neutral-400'}`} />
        </div>
        <div className="text-left">
          <p className="font-medium text-sm">
            {title}
          </p>
          {subtitle && (
            <p className="text-xs text-neutral-300/70 mt-0.5">
              {subtitle}
            </p>
          )}
        </div>
      </div>
      <FiChevronRight className={`h-5 w-5 ${danger ? 'text-red-400' : 'text-neutral-400'}`} />
    </button>
  );

  return (
    <div className='max-w-2xl mx-auto p-4'>
      {/* Header con botón de regreso */}
      <div className="mb-6">
        <button
          onClick={() => navigate('/mi-cuenta')}
          className="flex items-center space-x-2 text-neutral-400 hover:text-neutral-300 transition-colors"
        >
          <FiArrowLeft className="h-5 w-5" />
          <span className="text-sm">
            Volver a Mi Cuenta
          </span>
        </button>
      </div>

      {/* Título de la página */}
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-white">
          Gestión de Cuenta
        </h1>
        <p className="text-neutral-300 text-sm mt-1">
          Configura la seguridad y accesos de tu cuenta
        </p>
      </div>

      {/* Card con opciones de gestión */}
      <div className="bg-neutral-900/40 rounded-xl overflow-hidden">
        <MenuItem
          icon={FiAtSign}
          title="Cambiar correo electrónico"
          subtitle="Actualiza tu dirección de email"
          onClick={() => navigate('/mi-cuenta/gestion/cambiar-email')}
        />
        <MenuItem
          icon={FiLock}
          title="Cambiar contraseña"
          subtitle="Actualiza tu contraseña de seguridad"
          onClick={() => navigate('/mi-cuenta/gestion/cambiar-password')}
        />
        <MenuItem
          icon={FiXCircle}
          title="Desactivar cuenta"
          subtitle="Desactiva temporalmente tu cuenta"
          onClick={() => navigate('/mi-cuenta/gestion/desactivar-cuenta')}
          danger
          last
        />
      </div>
    </div>
  );
};

export default GestionCuenta;
